import React from 'react';
import FlairIcon, { SizeProp } from '../../../../atomic/atoms/FlairIcon';

import HolidayPopover from '../HolidayPopover';
import { Holiday } from '../HolidayPopover/types';

type Props = {
  size?: SizeProp;
  holidayPopoverInfo?: Holiday;
};

const HolidayIcon: React.FC<React.PropsWithChildren<Props>> = ({
  size,
  holidayPopoverInfo,
}) => (
  <FlairIcon
    icon="calendar-clear-outline"
    size={size}
    popover={
      holidayPopoverInfo ? (
        <HolidayPopover holiday={holidayPopoverInfo} />
      ) : undefined
    }
  />
);

export default HolidayIcon;
